import { Users } from '@platform/client';
import { GetCurrentUser200 } from '@platform/client/schemas';
import NextBestActions from '../next-best-actions';
import NextStepsSegment from './NextSteps/NextStepsSegment';
import BusinessChallengesSection from '../business-challenges';
import { RejoinPanel } from './RejoinPanel';
import {
  isCorporateProNoCohort,
  isInactiveUser,
  isNonCorporatePro,
} from '../../util/ProgramHelpers';
import { IndividualInactivePanel } from './IndividualInactiveUserPanel';
import { userApplicationApproved } from '../../app';

/** The main content panel of the dashboard home page */
const DashboardHomePanel = () => {
  const { isSuccess, data: user } = Users.useGetCurrentUser({
    query: {
      // Throw an error if we fail to fetch user data after retries are complete
      // TODO: Find a more graceful way to error the frontend when we are unable to fetch core app data like this, outside of the Dashboard feature
      throwOnError: true, 
    },
  });
  const isNonCorpPro = isNonCorporatePro(user);
  const hasDashboardAccess =
    userApplicationApproved(user) &&
    !isNonCorpPro &&
    !isInactiveUser(user) &&
    !isCorporateProNoCohort(user);

  return (
    <div className='px-4 sm:pl-11 w-full md:w-[920px] min-w-0 flex flex-col gap-4'>
      <div className='flex flex-col gap-4'>
        <div className='text-3xl'>Welcome back{isSuccess && `, ${user?.firstName}`}</div>
        {hasDashboardAccess ?
          <>
            {isSuccess && user?.accountType === 'experteer' && <NextBestActions user={user as GetCurrentUser200} />}
            {user?.accountType === 'organization' && user?.organization?.id && (
              <BusinessChallengesSection organizationId={user.organization.id} />
            )}
            {user?.accountType === 'experteer' && <NextStepsSegment />}
          </>
        : isNonCorpPro ?
          <IndividualInactivePanel />
        : <RejoinPanel user={user} />}
      </div>
    </div>
  );
};

export default DashboardHomePanel;
